// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"217":"c47da17a","348":"2adfb68c","836":"70cd3d86","887":"eb58ccc6"}[chunkId] + ".chunk.css";
};